module.exports = __webpack_public_path__ + "images/illustrations/icons/icon-source-0bbf5982197a814dcadc69f44134bcac.webp";